module.exports = __webpack_public_path__ + "img/VC.e789b8f8.svg";